module.exports = __webpack_public_path__ + "01_medium_gold.68d2ce03.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_medium_gold.png
// module id = PXZ7
// module chunks = 0